import { render, staticRenderFns } from "./FarmulaForm.vue?vue&type=template&id=ffa8203e&"
import script from "./FarmulaForm.vue?vue&type=script&lang=js&"
export * from "./FarmulaForm.vue?vue&type=script&lang=js&"
import style0 from "./FarmulaForm.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports